import lang from '../../../lang/index.js';
export default function base64Image() {
    return this
        .matches(/^data:image\/\w+;base64,/, lang().validation.base64ImageInvalid());
}
//# sourceMappingURL=index.js.map